import { createContext, useContext, useSyncExternalStore } from 'react';

// Native browser islands sit above the React composition tree. Let transcript
// surfaces suspend their live island while any popup is open. The transcript
// retains its captured viewport (or React fallback) behind the popup.
const popups = new Set();
const listeners = new Set();
const subscribe = listener => { listeners.add(listener); return () => listeners.delete(listener); };
const snapshot = () => popups.size;
export const WindowsPopupDepth = createContext(0);
const notify = () => listeners.forEach(listener => listener());
export function registerWindowsPopup() {
  const token = {}; popups.add(token); notify();
  return () => { if (popups.delete(token)) notify(); };
}
export function useWindowsPopupVisible() {
  const depth = useContext(WindowsPopupDepth);
  return useSyncExternalStore(subscribe, snapshot, snapshot) > depth;
}
